export default __webpack_public_path__ + "static/media/accommodations1_668.6bc017ad.webp";